import { cn } from '@blink/ui';
import { ChevronsRight } from 'lucide-react';
import { useRef, useState } from 'react';

/**
 * Swipe to confirm (plan 4.5 screen 4): the courier slides the handle to the end. A tap on the
 * track does not count; the handle must be dragged (or moved with the keyboard) most of the way.
 */
export function SwipeToConfirm({ label, disabled, onConfirm }: { label: string; disabled?: boolean; onConfirm: () => void }) {
  const [value, setValue] = useState(0);
  const last = useRef(0);
  const reset = () => {
    if (last.current < 100) {
      last.current = 0;
      setValue(0);
    }
  };
  return (
    <div className={cn('relative h-14 overflow-hidden rounded-full', disabled ? 'bg-muted' : 'bg-success-soft')}>
      <div className={cn('absolute inset-y-0 left-0 rounded-full', disabled ? '' : 'bg-success/25')} style={{ width: `calc(${value}% * 0.78 + 3.5rem)` }} />
      <span className={cn('pointer-events-none absolute inset-0 flex items-center justify-center ps-10 text-sm font-semibold', disabled ? 'text-muted-foreground' : 'text-success')}>
        {label}
        <ChevronsRight className="ms-1 h-4 w-4" />
      </span>
      <input
        type="range"
        min={0}
        max={100}
        step={1}
        value={value}
        disabled={disabled}
        aria-label={label}
        data-testid="swipe"
        className="swipe absolute inset-0 h-full w-full cursor-pointer appearance-none bg-transparent disabled:cursor-not-allowed"
        onChange={(e) => {
          const next = Number(e.target.value);
          // jumping straight to the end (a tap on the track) does not confirm
          if (next >= 100 && last.current < 50) return reset();
          last.current = next;
          setValue(next);
          if (next >= 100) onConfirm();
        }}
        onPointerUp={reset}
        onTouchEnd={reset}
        onBlur={reset}
      />
    </div>
  );
}
